export const BUILD_INFO = {
  "sha": "bb12a3a59248ac5057a3684fc1cc8996432d9099",
  "branch": "main",
  "builtAt": "2026-05-12T17:45:19.045Z"
};
